/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'
import { COLORS } from '@btime/constants'

import { sideMenuWidth } from '../navigation/SideMenu'
import MainMenu from '../../modules/menu/mainMenu/MainMenu'
import ExpiredContractMessage from '../messenger/ExpiredContractMessage'
import PendingBillingMessage from '../messenger/PendingBillingMessage'
import ProcessesFeatureMessage from '../messenger/ProcessesFeatureMessage'

const IframeTemplate = ({ children, bgColor }) => {
  const style = css`
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    padding-left: ${sideMenuWidth}rem;
    right: 0;
    bottom: 0;
    overflow: scroll;
    min-height: 100vh;
    background-color: ${bgColor || COLORS.light1};
  `
  return (
    <div css={style}>
      <ExpiredContractMessage />
      <PendingBillingMessage />
      <ProcessesFeatureMessage />
      {children}
      <MainMenu />
    </div>
  )
}

export default IframeTemplate
